// Toggle visibility of Appstle loyalty widgets on mobile product pages
(function () {
  "use strict";

  var TARGET_IDS = ["appstle_loyalty_iframe", "appstle-loyalty-button"];

  function isProductPage() {
    if (document.body.classList.contains("template-product")) return true;
    if (location && /\/products\//.test(location.pathname)) return true;
    return !!document.querySelector('form[action*="/cart/add"]');
  }

  function isMobile() {
    try {
      return (
        window.matchMedia && window.matchMedia("(max-width: 749px)").matches
      );
    } catch (e) {
      return false;
    }
  }

  function saveAndHide(el) {
    if (!el) return;
    if (el.getAttribute("data-appstle-hidden-by-toggle") === "true") return;
    var orig = el.getAttribute("style");
    el.setAttribute("data-appstle-original-style", orig === null ? "" : orig);
    el.style.setProperty("display", "none", "important");
    el.setAttribute("data-appstle-hidden-by-toggle", "true");
  }

  function restoreIfOwned(el) {
    if (!el) return;
    if (el.getAttribute("data-appstle-hidden-by-toggle") !== "true") return;
    var orig = el.getAttribute("data-appstle-original-style");
    if (orig === null || orig === "") el.removeAttribute("style");
    else el.setAttribute("style", orig);
    el.removeAttribute("data-appstle-original-style");
    el.removeAttribute("data-appstle-hidden-by-toggle");
  }

  function hideAppstleWidgets() {
    TARGET_IDS.forEach(function (id) {
      saveAndHide(document.getElementById(id));
    });
  }

  function showAppstleWidgetsIfOwned() {
    TARGET_IDS.forEach(function (id) {
      restoreIfOwned(document.getElementById(id));
    });
  }

  function debounced(fn, wait) {
    var t = null;
    return function () {
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        try {
          fn.apply(null, args);
        } catch (e) {}
      }, wait);
    };
  }

  function init() {
    if (!isProductPage()) return;
    var productForm = document.querySelector('form[action*="/cart/add"]');
    if (!productForm) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          // If not mobile or not a product page, restore only if we hid them
          if (!isMobile()) {
            showAppstleWidgetsIfOwned();
            return;
          }

          if (entry.isIntersecting) {
            // Add-to-cart visible: hide loyalty widgets
            hideAppstleWidgets();
          } else {
            // Add-to-cart off-screen: restore if we hid them
            showAppstleWidgetsIfOwned();
          }
        });
      },
      { threshold: 0 },
    );

    observer.observe(productForm);

    // Also respond to viewport changes
    var onChange = debounced(function () {
      // when switching to desktop view, restore; when switching to mobile, re-evaluate
      if (!isMobile()) {
        showAppstleWidgetsIfOwned();
      }
    }, 150);

    window.addEventListener("resize", onChange);
    window.addEventListener("orientationchange", onChange);
    document.addEventListener("DOMContentLoaded", function () {
      /* no-op ensures DOM ready */
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
